import React, { useEffect, useState } from "react";
import { getNotificaciones } from "../api";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { motion } from "framer-motion";
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const tiempoTranscurrido = (fecha) => {
  const pasada = new Date(fecha);
  const ahora = new Date();
  const diff = (ahora - pasada) / 1000;

  if (diff < 60) return "Justo ahora";
  if (diff < 3600) return `Hace ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `Hace ${Math.floor(diff / 3600)} h`;
  if (diff < 172800) return "Ayer";
  return pasada.toLocaleDateString("es-GT");
};

const Notificaciones = () => {
  const { user, authReady } = useAuth();
  const navigate = useNavigate();
  const [notificaciones, setNotificaciones] = useState([]);
  const [loadingNoti, setLoadingNoti] = useState(true);
  const showSplash = useDynamicSplash(loadingNoti);

  useEffect(() => {
    if (!authReady) return;
    if (!user?.id) {
      navigate("/login", { replace: true });
    }
  }, [authReady, user]);

  const obtenerIconoPorTipo = (tipo) => {
    switch (tipo) {
      case 1: // 🎯 Visualizaciones
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16"><path fill="#fff" d="M6 7a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 7m.5 1.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zM2 8a6 6 0 1 1 2.996 5.195l-2.338.78a.5.5 0 0 1-.639-.612l.712-2.491A6 6 0 0 1 2 8m6-5a5 5 0 0 0-4.3 7.552a.5.5 0 0 1 .05.393l-.509 1.78l1.658-.552a.5.5 0 0 1 .426.052A5 5 0 1 0 8 3"></path></svg>
        );
      case 2: // 📩 Mensajes
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48">
                <path fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="m7.369 28.832l30.755-5.516l5.376-9.143l-8.245-5.958L4.5 13.73z" strokeWidth="1.8" />
                <path fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="m10.494 28.272l7.997 11.513l23.522-15.73l1.487-9.882" strokeWidth="1.8" />
                <circle cx="39.339" cy="14.912" r=".75" fill="#fff" />
        </svg>
        );
      case 3: // 👁️ Seguidores
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32">
                <path fill="#fff" d="M19 2a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3v1.493c0 1.361 1.668 2.019 2.597 1.024L23.945 13H27a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm-2 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-3.272a.5.5 0 0 0-.366.159l-2.496 2.675a.5.5 0 0 1-.866-.341V12.5a.5.5 0 0 0-.5-.5H19a2 2 0 0 1-2-2zm-6.5 4a4 4 0 1 0 0 8a4 4 0 0 0 0-8m-5 4a5 5 0 1 1 10 0a5 5 0 0 1-10 0M2 23a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v.5c0 .6-.28 2.216-1.488 3.692C16.282 28.694 14.135 30 10.5 30s-5.783-1.306-7.012-2.808C2.281 25.716 2 24.1 2 23.5zm3-2a2 2 0 0 0-2 2v.5c0 .4.22 1.784 1.262 3.058C5.282 27.806 7.135 29 10.5 29s5.217-1.194 6.238-2.442C17.781 25.284 18 23.9 18 23.5V23a2 2 0 0 0-2-2z" strokeWidth=".2" stroke="#fff" />
            </svg>
        );
      case 4: // 🎉 Bienvenida
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1">
                    <path d="M20.925 13.163A8.998 8.998 0 0 0 12 3a9 9 0 0 0 0 18M9 10h.01M15 10h.01" />
                    <path d="M9.5 15c.658.64 1.56 1 2.5 1s1.842-.36 2.5-1m.5 4l2 2l4-4" />
                </g>
            </svg>
        );
      case 5: // ⚠️ Reporte
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="#fff" d="m10.95 13.43l-1.796-1.79q-.14-.14-.341-.15q-.202-.01-.367.156q-.16.16-.16.354t.16.354l1.938 1.938q.243.242.566.242t.566-.242l4.038-4.038q.146-.146.153-.344q.007-.199-.153-.364q-.165-.165-.357-.168t-.356.162zm-2.28 7.186l-1.316-2.2l-2.481-.524q-.298-.055-.475-.32q-.177-.264-.146-.562l.237-2.556l-1.683-1.92q-.212-.217-.212-.534t.212-.534l1.683-1.92l-.237-2.555q-.03-.299.146-.563q.177-.264.475-.32l2.48-.523l1.316-2.2q.162-.268.435-.37q.273-.103.565.027L12 4.027l2.33-.985q.293-.13.566-.027q.273.102.435.37l1.315 2.2l2.481.523q.298.056.475.32t.146.563l-.236 2.555l1.682 1.92q.212.217.212.534t-.212.535l-1.682 1.919l.236 2.555q.03.299-.146.563q-.177.265-.475.32l-2.48.524l-1.316 2.2q-.162.267-.435.37t-.565-.028L12 19.973l-2.33.985q-.293.13-.566.027q-.273-.102-.435-.37m.781-.665L12 18.889l2.562 1.061L16 17.55l2.75-.611l-.25-2.839l1.85-2.1l-1.85-2.111l.25-2.839l-2.75-.6l-1.45-2.4L12 5.112L9.439 4.05L8 6.45l-2.75.6l.25 2.839L3.65 12l1.85 2.1l-.25 2.85l2.75.6zM12 12"></path>
            </svg>
        );
        case 6: // ⚠️ Reporte
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="#fff" d="M11.5 18c4 0 7.46-2.22 9.24-5.5C18.96 9.22 15.5 7 11.5 7s-7.46 2.22-9.24 5.5C4.04 15.78 7.5 18 11.5 18m0-12c4.56 0 8.5 2.65 10.36 6.5C20 16.35 16.06 19 11.5 19S3 16.35 1.14 12.5C3 8.65 6.94 6 11.5 6m0 2C14 8 16 10 16 12.5S14 17 11.5 17S7 15 7 12.5S9 8 11.5 8m0 1A3.5 3.5 0 0 0 8 12.5a3.5 3.5 0 0 0 3.5 3.5a3.5 3.5 0 0 0 3.5-3.5A3.5 3.5 0 0 0 11.5 9"></path>
            </svg>
        );
        case 7: // ⚠️ Reporte
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 28 28">
                <path fill="#fff" d="M15 20a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-1.75-3.25a.75.75 0 0 0 1.5 0v-6.5a.75.75 0 0 0-1.5 0zM11.592 4.17c1.046-1.894 3.77-1.895 4.816 0l9.25 16.75c1.012 1.833-.314 4.08-2.407 4.08H4.757c-2.093 0-3.42-2.246-2.408-4.079zm3.502.725a1.25 1.25 0 0 0-2.188 0L3.662 21.646A1.25 1.25 0 0 0 4.757 23.5H23.25a1.25 1.25 0 0 0 1.094-1.854z"></path>
            </svg>
        );
        case 8: // ⚠️ Reporte
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 256 256">
                <path fill="#fff" d="M208.77 32a24 24 0 0 0-44 5.79L148 100.54L131.19 37.8a24 24 0 0 0-46.37 12.42l11 41.17l-15-2.9a24 24 0 0 0-17.49 43.87l-.55.35a23.85 23.85 0 0 0-10.28 15.22a24.7 24.7 0 0 0-.49 4.89V160a76 76 0 0 0 76 76h.59c41.58-.31 75.42-34.81 75.42-76.9v-3.34a51.9 51.9 0 0 0-12.17-33.35l19.34-72.19A23.82 23.82 0 0 0 208.77 32M94.15 36a16 16 0 0 1 29.31 3.86l16.19 60.42a24 24 0 0 0-20.58 6.72a24.4 24.4 0 0 0-2.24-4.25a23.75 23.75 0 0 0-12.17-9.41L92.55 48.15A15.9 15.9 0 0 1 94.15 36m-33.82 72.8a16 16 0 0 1 18.92-12.46l20.76 4a16 16 0 1 1-6.44 31.34l-20.79-4a16 16 0 0 1-12.45-18.87Zm0 40.72A16 16 0 0 1 79.09 137l10.11 2a16 16 0 1 1-6.42 31.35l-10-2a16 16 0 0 1-12.47-18.88ZM196 159.1c0 37.71-30.28 68.62-67.48 68.9A68 68 0 0 1 61 171.43a23.75 23.75 0 0 0 10.24 4.81l10 2a24 24 0 0 0 4.85.49A23.9 23.9 0 0 0 104 138.88a24.1 24.1 0 0 0 9.75-5.89a25 25 0 0 0 2.24 4.25a23.83 23.83 0 0 0 15.24 10.28l10.5 2.11A32.3 32.3 0 0 0 140 160a31.85 31.85 0 0 0 9.14 22.4a4 4 0 0 0 5.71-5.6a24 24 0 0 1-4-28.22a4 4 0 0 0-2.73-5.83l-15.35-3.07a16 16 0 1 1 6.42-31.35l21.4 4.28A44.12 44.12 0 0 1 196 155.76Zm7.45-110.95l-18.15 67.73a51.6 51.6 0 0 0-23.11-11.11l-6.68-1.34l17-63.56a16 16 0 0 1 30.91 8.28Z"></path>
            </svg>
        );
        case 9: //XXXX Comenzó a seguir a XXXX
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill="#fff" d="m10.95 13.43l-1.796-1.79q-.14-.14-.341-.15q-.202-.01-.367.156q-.16.16-.16.354t.16.354l1.938 1.938q.243.242.566.242t.566-.242l4.038-4.038q.146-.146.153-.344q.007-.199-.153-.364q-.165-.165-.357-.168t-.356.162zm-2.28 7.186l-1.316-2.2l-2.481-.524q-.298-.055-.475-.32q-.177-.264-.146-.562l.237-2.556l-1.683-1.92q-.212-.217-.212-.534t.212-.534l1.683-1.92l-.237-2.555q-.03-.299.146-.563q.177-.264.475-.32l2.48-.523l1.316-2.2q.162-.268.435-.37q.273-.103.565.027L12 4.027l2.33-.985q.293-.13.566-.027q.273.102.435.37l1.315 2.2l2.481.523q.298.056.475.32t.146.563l-.236 2.555l1.682 1.92q.212.217.212.534t-.212.535l-1.682 1.919l.236 2.555q.03.299-.146.563q-.177.265-.475.32l-2.48.524l-1.316 2.2q-.162.267-.435.37t-.565-.028L12 19.973l-2.33.985q-.293.13-.566.027q-.273-.102-.435-.37m.781-.665L12 18.889l2.562 1.061L16 17.55l2.75-.611l-.25-2.839l1.85-2.1l-1.85-2.111l.25-2.839l-2.75-.6l-1.45-2.4L12 5.112L9.439 4.05L8 6.45l-2.75.6l.25 2.839L3.65 12l1.85 2.1l-.25 2.85l2.75.6zM12 12"></path>
            </svg>
        );
        case 10: //Pago por QX recibido correctamente.
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" stroke="#fff" stroke-linecap="round" strokeLinejoin="round" strokeWidth="1" color="currentColor">
              <path d="M14 18.5s1 0 2 2c0 0 3.177-5 6-6m-16.5-3h-.009m5.509 8h-.5c-3.759 0-5.638 0-6.893-.99a4.4 4.4 0 0 1-.554-.523C2 16.807 2 15.037 2 11.5s0-5.306 1.053-6.487q.253-.284.554-.522C4.862 3.5 6.741 3.5 10.5 3.5h3c3.759 0 5.638 0 6.892.99q.302.24.555.523C21.896 6.077 21.99 7.618 22 10.5v.5" />
              <path d="M14.5 11.5a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0" />
            </g>
          </svg>
        );
        case 11: //Recibiste QX a tu cuenta.
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" stroke="#ffffff" strokeWidth="1">
              <path stroke-linecap="round" strokeLinejoin="round" strokeWidth="1" d="M6 9h4" opacity="0.5" />
              <path strokeWidth="1" d="M20.833 10h-2.602C16.446 10 15 11.343 15 13s1.447 3 3.23 3h2.603c.084 0 .125 0 .16-.002c.54-.033.97-.432 1.005-.933c.002-.032.002-.071.002-.148v-3.834c0-.077 0-.116-.002-.148c-.036-.501-.465-.9-1.005-.933c-.035-.002-.076-.002-.16-.002Z" />
              <path strokeWidth="1" d="M20.965 10c-.078-1.872-.328-3.02-1.137-3.828C18.657 5 16.771 5 13 5h-3C6.229 5 4.343 5 3.172 6.172S2 9.229 2 13s0 5.657 1.172 6.828S6.229 21 10 21h3c3.771 0 5.657 0 6.828-1.172c.809-.808 1.06-1.956 1.137-3.828" />
              <path strokeLinecap="round" strokeWidth="1" d="m6 5l3.735-2.477a3.24 3.24 0 0 1 3.53 0L17 5" opacity="0.5" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M17.991 13H18" opacity="0.5" />
            </g>
          </svg>
        );
      // Agregá más según el tipo que tengas
      default: // 🔔 Default
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16">
            <path fill="#fff" d="M6 7a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 6 7" />
          </svg>
        );
    }
  };  

  useEffect(() => {
    const cargar = async () => {
      setLoadingNoti(true);
      document.body.style.overflow = "hidden";
      try {
        const data = await getNotificaciones(user?.id);
        setNotificaciones(data);
      } finally {
        setLoadingNoti(false);
        document.body.style.overflow = "auto";
        window.scrollTo(0, 0);
      }
    };
    if (user?.id) cargar();
  }, [user]);

  return (
    <>
      {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}
      {!showSplash && (
       <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
    <div className="app-container">
      <div className="notifications-container">
            <div className="back-container">
              <button className="back-btn" onClick={() => navigate(`/`)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
                      <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M244 400L100 256l144-144M120 256h292"></path>
                  </svg>
              </button>
          </div>
        <h2 className="notification-title">Tus notificaciones</h2>
        <div className="notifications-list">
          {notificaciones.map((n, i) => (
              <div key={i} className={`notification ${n.leido === 0 ? 'unread' : ''}`}>
              <div className="notification-icon">
                  {obtenerIconoPorTipo(n.tipo)}
              </div>
              <div className="notification-content">
                <p dangerouslySetInnerHTML={{ __html: n.mensaje }}></p>
                <small>{tiempoTranscurrido(n.fecha)}</small>
              </div>
            </div>
          ))}
          {notificaciones.length === 0 && (
            <p style={{ padding: 20, textAlign: "center", color: "#aaa" }}>
              No tienes notificaciones todavía.
            </p>
          )}
        </div>
      </div>
    </div>
    </motion.div>
    )}
    </>
  );
};

export default Notificaciones;
